<template>
  <th scope="col">
    <div
      class="d-flex align-items-center white-space-none"
      :class="alignment === 'right' ? 'justify-content-end' : ''"
    >
      <span>{{ label }}</span>

      <product-variants-table-tooltip
        v-if="tooltipText != ''"
        :tooltip-text="
          getProductPageTranslations[
            'ProductDetail.VariantsTable.Headings.SafetyTooltip'
          ]
        "
      />
    </div>
  </th>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductVariantsTableTooltip from './product-variants-table-tooltip.vue';

export default {
  components: {
    ProductVariantsTableTooltip
  },
  props: {
    alignment: {
      type: String,
      default: 'left'
    },
    label: {
      type: String,
      default: ''
    },
    tooltipText: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('translations', ['getProductPageTranslations'])
  }
};
</script>
